import React, { useState, useEffect } from "react";
import { II } from "../../components/common/Icons";
import { ITA_NAV } from "../../data/itaData";
import api from "../../services/api";
import { useAuth } from "../../context/AuthContext";import "../../assets/styles/ITAdmin/ITASidebar.css";

function ITASidebar({ a, set, onLogout, sidebarOpen, setSidebarOpen }) {
  const { user } = useAuth();
  const [pendingReqs, setPendingReqs] = useState(0);
  const [unreadChat, setUnreadChat] = useState(0);
  const initials = (user?.name || "IT").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, 10000);
    return () => clearInterval(interval);
  }, []);

  // Re-fetch when switching back to requests tab
  useEffect(() => {fetchCount();}, [a]);

  const fetchCount = async () => {
    try {
      const data = await api.getITRequests();
      setPendingReqs((data || []).filter((r) => (r.status || "pending") === "pending").length);
    } catch (e) {}
    try {
      const notifs = await api.getNotifications();
      setUnreadChat((notifs || []).filter((n) => n.type === "chat" && !n.is_read).length);
    } catch (e) {}
  };

  return <div className={`SB ${sidebarOpen ? "SB-open" : "SB-closed"}`} onMouseEnter={() => setSidebarOpen?.(true)} onMouseLeave={() => setSidebarOpen?.(false)}><div className="SB-hd"><img src="/logo.png" alt="AMS" className="SB-logo itasidebar-inline-1" /><div><div className="itasidebar-inline-2">AMSHRMS</div><div className="itasidebar-inline-3">IT Admin</div></div></div><nav className="SB-nav"><div className="SB-sec">Overview</div>{ITA_NAV.slice(0, 1).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(n.i)}<span>{n.l}</span></div>)}<div className="SB-sec">Management</div>{ITA_NAV.slice(1, 4).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(n.i)}<span>{n.l}</span></div>)}<div className="SB-sec">Operations</div>{ITA_NAV.slice(4).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(n.i)}<span>{n.l}</span>{n.k === "requests" && pendingReqs > 0 && <span className="bg">{pendingReqs}</span>}{n.k === "chat" && unreadChat > 0 && <span className="bg">{unreadChat}</span>}</div>)}</nav><div className="SB-ft"><div className="itasidebar-inline-4"><div className="itasidebar-inline-5">{initials}</div><div><div className="itasidebar-inline-6">{user?.name || "IT Admin"}</div><div className="itasidebar-inline-7">{user?.id || "IT Admin"}</div></div></div><button onClick={onLogout} className="itasidebar-inline-8">{II("logout")} Sign Out</button></div></div>;
}

export default ITASidebar;
